import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const MainSlideModal2 = styled.div`
  border-radius: 8px 8px 0 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  overflow: hidden;

  .content {
    .swiper {
      border-radius: 8px 8px 0 0;

      .img {
        padding-bottom: 74.93333333333333%;
        background-color: #fff;
      }
    }

    .swiper-pagination-fraction {
      position: absolute;
      top: 20px;
      right: 20px;
      border-radius: 20px;
      padding: 5px 8px;
      font-size: 10px;
      bottom: auto;
      left: auto;
      width: auto;
      display: inline-block;
      background-color: rgba(0, 0, 0, 0.3);
      text-align: center;
      font-weight: 500;
      line-height: 110%;
      color: #fff;
      z-index: 1;
    }
  }

  .area-text {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: ${mixin.pxToVw('56 32 20 32')};
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );
    ${mixin.flex({
      direction: 'column',
      align: 'flex-start',
      justify: 'flex-start',
    })};

    .text-wrap {
      width: 100%;
      max-width: ${mixin.pxToVw('184')};
    }

    .title {
      font-size: ${mixin.pxToVw('20')};
      line-height: 130%;
      text-align: left;

      .title2,
      .title1 {
        display: block;
        font-weight: 600;
        ${mixin.ellipsis(1)};
      }
    }

    .sub-title {
      margin-top: ${mixin.pxToVw('10')};
      font-size: ${mixin.pxToVw('13')};
      line-height: 130%;
      text-align: left;

      .sub-title2,
      .sub-title1 {
        display: block;
        ${mixin.ellipsis(1)};
      }
    }
  }

  .btn-link {
    width: calc(100% - ${mixin.pxToVw('64')}) !important;
    height: ${mixin.pxToVw('50')};
    background-color: #000;
    color: #fff;
    font-size: ${mixin.pxToVw('15')};
    font-weight: 500;
    line-height: 130%;
    position: absolute;
    bottom: ${mixin.pxToVw('20')};
    left: 50%;
    transform: translateX(-50%);
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('8 8 0 0')};

    .content {
      .swiper {
        border-radius: ${mixin.pxToVw('8 8 0 0')};
      }

      .swiper-pagination-fraction {
        top: ${mixin.pxToVw('20')};
        right: ${mixin.pxToVw('20')};
        border-radius: ${mixin.pxToVw('20')};
        padding: ${mixin.pxToVw('5 8')};
        font-size: ${mixin.pxToVw('10')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);

    .content {
      .swiper {
        width: 375px;
        height: 281px;
      }

      .swiper-button-autoplay-control,
      .swiper-button-prev,
      .swiper-button-next {
        top: auto;
        left: auto;
        transform: none;
        transition: none;
        bottom: 16px;
      }

      .swiper-button-autoplay-control {
        right: 32px;
      }

      .swiper-button-next {
        right: 68px;
      }

      .swiper-button-prev {
        right: 100px;
      }
    }

    .area-text {
      padding: 56px 32px 20px 32px;

      .text-wrap {
        max-width: 184px;
      }

      .title {
        font-size: 20px;
      }

      .sub-title {
        margin-top: 10px;
        font-size: 13px;
      }
    }

    .btn-link {
      width: calc(100% - 64px) !important;
      height: 50px;
      font-size: 15px;
      bottom: 20px;
    }

    .content:has(.swiper-slide-active .btn-link) {
      .swiper-button-autoplay-control,
      .swiper-button-prev,
      .swiper-button-next {
        bottom: 82px;
      }
    }
  }
`;
